import React from 'react';
import { MenuItem, Select, SelectChangeEvent, FormHelperText } from '@mui/material';

// Utils
import { RECOVERY_QUESTIONS } from '@utils/constants';

interface SelectComponentProps {
  handleChange: (e: SelectChangeEvent<string | null>) => void;
  question: string | null;
  error: { [key: string]: string };
}

const SelectComponent: React.FC<SelectComponentProps> = ({ handleChange, question, error }) => {
  return (
    <>
      <Select
        name="question"
        value={question}
        label="Recovery Question"
        fullWidth
        onChange={handleChange}
        error={!!error.question}
      >
        {RECOVERY_QUESTIONS.map((question: string) => (
          <MenuItem key={question} value={question}>
            {question}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText className="error-text">{error.question}</FormHelperText>
    </>
  );
};

export default SelectComponent;
